<template>
    <!-- <div :class="option.size+' image-box'"> -->
    <el-image 
        :src="thumb ? thumb : require('@/assets/icon/defualt-image2.png')" 
        fit="cover" 
        loading="lazy" 
        :class="option.size"
        :preview-src-list="option.showBig ? [thumb] : []"
        preview-teleported="true"
    />
    <!-- <el-image :src="require('@/assets/icon/player.png')" v-if="option.thumbtype==2" class="video-player" />
    </div> -->
</template>

<script>
export default {
  props: ['value','option'],
  data() {
      return {
          thumb: this.value,
          option: {
              size:this.option && this.option.size ? this.option.size : 'large', //large-大图 middle-中图 small-小图 mini-迷你图
              showBig:this.option && this.option.showBig? this.option.showBig : false, //是否显示大图
              thumbtype:this.option && this.option.thumbtype? this.option.thumbtype : 1, //是否图片 1-图片 2-视频，视频文件在中间显示icon
          },
      }
  },

  watch: {
      value(val) {
          this.thumb=val;
      },
  },

  mounted() {
      
  },

  methods: {


  }

}
</script>

<style scoped>
.large {width:100px;height: 100px;border-radius: 15px;}
.middle {width:70px;height: 70px;border-radius: 10px;}
.small {width:40px;height: 40px;border-radius: 6px;}
.mini {width:25px !important;height: 25px !important;border-radius: 3px;}
.image-box {position: relative;}
.video-player {width:30px;height: 30px;position:absolute;top:0;left:calc((100% - 30px) / 2);top:calc((100% - 30px) / 2);}
</style>